import { render, staticRenderFns } from "./DataMng.vue?vue&type=template&id=5562f9ff&scoped=true&"
import script from "./DataMng.vue?vue&type=script&lang=js&"
export * from "./DataMng.vue?vue&type=script&lang=js&"
import style0 from "./DataMng.vue?vue&type=style&index=0&id=5562f9ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5562f9ff",
  null
  
)

export default component.exports